module.exports = __webpack_public_path__ + "static/0025-fae3b91c5d57d86753a18f80fe164dad.png";